import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-valuation-order-confirmation-dialog',
    templateUrl: './valuation-order-confirmation-dialog.component.html',
    styleUrls: ['./valuation-order-confirmation-dialog.component.scss'],
})
export class ValuationOrderConfirmationDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ValuationOrderConfirmationDialogComponent>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {
        this.addSvgIcon('interface-delete 1');
        this.addSvgIcon('aumico-pattern-icon-task-check');
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
